/* eslint-disable linebreak-style */
import React from 'react';
import {connect} from 'react-redux';
import clsx from 'clsx';
import PerfectScrollbar from 'react-perfect-scrollbar';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  colors
} from '@material-ui/core';
import {selectLookupFirmeComisionar} from '../../../../redux/lookup/lookup.selectors';
import { t } from '../../../../i18n';

const useStyles = makeStyles(() => ({
  root: {
    padding: '12px'
  },
  content: {
    padding: 0
  },
  inner: {
    width: 'auto'
  },
  header: {
    background: colors.blueGrey[700],
  },
  headCell: {
    fontWeight: 700
  }
}));

const AccountClientiComisionar = ({ className, firmeComisionar }) => {
  const classes = useStyles();
  const clienti = Array.isArray(firmeComisionar) ? firmeComisionar : [];

  return (
    <Card className={clsx(classes.root, className)}>
      <CardHeader
        className={classes.header}
        subheader={t('accountCommissioner.subheader')}
        title={t('accountCommissioner.title')}
      />
      <Divider />
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.headCell}>{t('accountCommissioner.name')}</TableCell>
                  <TableCell className={classes.headCell}>{t('accountCommissioner.city')}</TableCell>
                  <TableCell className={classes.headCell}>{t('accountCommissioner.county')}</TableCell>
                  <TableCell className={classes.headCell}>{t('accountCommissioner.address')}</TableCell>
                  <TableCell className={classes.headCell}>JV</TableCell>
                  <TableCell className={classes.headCell}>RO</TableCell>
                  <TableCell className={classes.headCell}>RE</TableCell>
                  <TableCell className={classes.headCell}>UG</TableCell>
                  <TableCell className={classes.headCell}>PI</TableCell>
                  <TableCell className={classes.headCell}>JO</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {clienti.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={10}>{t('accountCommissioner.noClients')}</TableCell>
                  </TableRow>
                ) : (
                  clienti.map(client => (
                    <TableRow hover key={client.id}>
                      <TableCell>{client.denumire || '-'}</TableCell>
                      <TableCell>{client.oras || '-'}</TableCell>
                      <TableCell>{client.judet || '-'}</TableCell>
                      <TableCell>{client.adresa || '-'}</TableCell>
                      <TableCell>{Number(client.discountJV || 0)}%</TableCell>
                      <TableCell>{Number(client.discountRO || 0)}%</TableCell>
                      <TableCell>{Number(client.discountRE || 0)}%</TableCell>
                      <TableCell>{Number(client.discountUG || 0)}%</TableCell>
                      <TableCell>{Number(client.discountPI || 0)}%</TableCell>
                      <TableCell>{Number(client.discountJO || 0)}%</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
    </Card>
  );
};

AccountClientiComisionar.propTypes = {
  className: PropTypes.string,
  firmeComisionar: PropTypes.array
};

const mapStateToProps = state => ({
  firmeComisionar: selectLookupFirmeComisionar(state)
});

export default connect(mapStateToProps)(AccountClientiComisionar);
